import HeaderMenu from './HeaderMenu'

export default function HeaderDesktop({ totalPosts }: { totalPosts: number }) {
  return (
    <ul className="mb-0 hidden w-full list-none items-center justify-end lg:flex">
      <HeaderMenu totalPosts={totalPosts || 10} />
    </ul>
  )
}
